import { useMonitoringCheckQuery } from "../../redux/slice/api/staticData";


const PageMonitoringCheck: React.FC = () => {
  const { data, isLoading } = useMonitoringCheckQuery();

  return (
    <div id="check_status">{!isLoading ? (data?.Return_Value ? data?.Return_Value : "ERROR") : ""}</div>
  );
};

export default PageMonitoringCheck;
